import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useWithdrawStore } from '@/store/useWithdrawStore'
import { useGetOnRampPricePerUnit } from '@/domain'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import { Skeleton } from '@/components/Skeleton'
import type { CryptoCode, FiatCode } from '@/constants/currencyCodes'

export const WithdrawAmountDisplay: React.FC = () => {
  const isFiatMode = useWithdrawStore((state) => state.isFiatMode)
  const fiatAmount = useWithdrawStore((state) => state.fiatAmount)
  const cryptoAmount = useWithdrawStore((state) => state.cryptoAmount)
  const triggerShake = useWithdrawStore((state) => state.triggerShake)
  const selectedCryptoWalletData = useWithdrawStore(
    (state) => state.selectedCryptoWalletData,
  )
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  // Проверяем состояние загрузки курса валют
  const {
    isLoading: isLoadingOnRampPrice,
    isFetching: isFetchingOnRampPrice,
  } = useGetOnRampPricePerUnit({
    crypto: (selectedCryptoWalletData?.code as CryptoCode) || 'USDT',
    fiat: (displayCurrency?.isin as FiatCode) || 'USD',
  })

  const isLoading = isLoadingOnRampPrice || isFetchingOnRampPrice

  const adaptedAmount = isFiatMode ? fiatAmount : cryptoAmount
  const displayAmount = adaptedAmount.amount || '0'

  // Вычисляем размер шрифта в зависимости от длины текста (как в RN)
  const getFontSizeForAmount = (text: string) => {
    const length = text.length
    if (length <= 8) return 64
    if (length <= 12) return 48
    if (length <= 16) return 36
    return 24
  }

  // Показываем skeleton loader во время загрузки
  if (isLoading) {
    return (
      <BaseView
        center
        style={{
          height: 74,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Skeleton
          viewBox="0 0 200 64"
          style={{
            width: 200,
            height: 64,
          }}
        >
          <rect rx="8" ry="8" width="200" height="64" />
        </Skeleton>
      </BaseView>
    )
  }

  return (
    <BaseView
      center
      style={{
        height: 74,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={triggerShake ? 'animate-shake' : ''}
    >
      <BaseText
        fontFamily="bold"
        color="label.default"
        style={{
          fontSize: getFontSizeForAmount(displayAmount),
          lineHeight: 1,
          letterSpacing: '-0.02em',
          maxWidth: '100%',
          textAlign: 'center',
          transition: 'font-size 0.2s ease',
        }}
      >
        {displayAmount}
      </BaseText>

      {/* Отображаем код валюты рядом с суммой */}
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.secondary"
        style={{
          marginTop: 4,
          textAlign: 'center',
        }}
      >
        {adaptedAmount.code}
      </BaseText>
    </BaseView>
  )
}
